<template>
    <!-- class="pt-24 pb-20 lg:pt-40 md:pt-52 dark:bg-black lg:px-0 md:px-4" -->
  <div
  class="pt-56"
    id="contact-page"
  >
    <div
      class="flex flex-col justify-center mx-auto maxWidth"
      data-aos="fade-up"
    >
      <div class="flex flex-col items-center md:items-end">
        <h1 class="text-6xl font-bold textBlue">Contact</h1>
        <p class="text-xl font-normal text-left dark:text-gray-300">
          Get the good stuff
        </p>
      </div>
      <div
        class="items-center justify-center w-full mx-auto mt-5 mb-20 md:mb-0 md:flex md:mt-28 md:h-96"
      >
        <div
          class="flex flex-col items-center justify-center gap-4 mb-10 md:gap-10 md:mb-0 md:w-1/2"
        >
          <div class="flex flex-col items-center gap-1">
            <Email />
            <h1 class="text-xl font-bold md:text-2xl dark:text-gray-300">
              Email
            </h1>
            <a
              href="mailto:davimuneeb785@gmail.com"
              class="text-lg font-normal text-black no-underline md:text-lg dark:text-gray-300"
              >davimuneeb785@gmail.com</a
            >
          </div>
          <div class="flex flex-col items-center gap-1">
            <Location />
            <h1 class="text-xl font-bold md:text-2xl dark:text-gray-300">
              Where to find me:
            </h1>
            <h1 class="text-lg font-normal md:text-lg dark:text-gray-300">
              Cape Town, South Africa
            </h1>
          </div>
          <div class="flex flex-col items-center gap-1">
            <Phone />
            <h1 class="text-xl font-bold md:text-2xl dark:text-gray-300">
              Call me on:
            </h1>
            <a
              href="tel:+27 76 162 1649"
              class="text-lg font-normal text-black no-underline md:text-lg dark:text-gray-300"
              >+27 76 162 1649</a
            >
          </div>
        </div>
        <form
          @submit.prevent="handleSubmit"
          id="contact-form"
          name="myForm"
          class="flex flex-col items-center justify-center w-full h-full gap-5 md:w-1/2"
          role="form"
        >
          <div class="w-full px-4 form-group lg:px-20 md:px-4">
            <input
              type="text"
              class="w-full p-3 font-medium border-0 rounded h-11 inputColor dark:bg-gray-100 dark:text-black focus:outline-none"
              id="name"
              name="name"
              placeholder="Name"
              tabindex="1"
              required
              v-model="name"
            />
          </div>

          <div class="w-full px-4 form-group lg:px-20 md:px-4">
            <input
              type="email"
              class="w-full p-3 font-medium border-0 rounded h-11 inputColor dark:bg-gray-100 dark:text-black focus:outline-none"
              id="email"
              name="email"
              placeholder="Email address"
              tabindex="2"
              required
              v-model="email"
            />
          </div>

          <div class="w-full px-4 form-group lg:px-20 md:px-4">
            <input
              type="text"
              class="w-full p-3 font-medium border-0 rounded h-11 inputColor dark:bg-gray-100 dark:text-black focus:outline-none"
              id="subject"
              name="subject"
              placeholder="Phone number"
              tabindex="3"
              required
              v-model="contact"
            />
          </div>

          <div class="w-full px-4 form-group lg:px-20 md:px-4">
            <textarea
              name="message"
              class="w-full h-32 p-3 font-medium border-0 rounded inputColor dark:bg-gray-100 dark:text-black focus:outline-none"
              id="message"
              placeholder="Message"
              tabindex="4"
              required
              v-model="message"
            ></textarea>
          </div>

          <div class="w-full px-4 text-center b margin-top-25 lg:px-20 md:px-4">
            <button
              type="submit"
              class="w-full text-white transition-all duration-500 bg-black border-none rounded shadow-md cursor-pointer btnColor hover:bg-white hover:text-black h-11 dark:bg-gray-100 dark:text-black"
            >
              <span class="font-semibold" v-show="!loading">Send Message</span>
              <span v-show="loading"><Loader /></span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../components/Loader.vue";
import Location from "../components/icons/Location.vue";
import Phone from "../components/icons/Phone.vue";
import Email from "../components/icons/Email.vue";
import AOS from "aos";
import { onMounted } from "vue";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
export default {
  name: "Contact",
  data() {
    return {
      name: "",
      email: "",
      contact: "",
      message: "",
      loading: "",
    };
  },
  components: { Loader, Location, Phone, Email },

  methods: {
    handleSubmit() {
      this.loading = true;
      // console.log(this.name, this.email, this.contact, this.message);
      fetch("https://port-backend-bice.vercel.app/contact", {
        method: "POST",
        body: JSON.stringify({
          name: this.name,
          email: this.email,
          contact: this.contact,
          message: this.message,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      })
        .then((response) => response.json())
        .then((json) => {
          toast.info(json.msg);
          return (
            ((this.name = ""),
            (this.email = ""),
            (this.contact = ""),
            (this.message = "")),
            (this.loading = false)
          );
        })
        .catch((error) => toast.error(error.msg));
    },
  },
  setup() {
    onMounted(() => {
      AOS.init();
    });
  },
};
</script>

<style scoped>
.inputColor {
  background: #f0f0f0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #101010;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #101010;
}

.btnColor {
  background: #101010;
}
:hover.btnColor {
  color: #1e90ff;
}
::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #101010;
}
</style>
